var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "remind-section",
      staticStyle: {
        "margin-top": "30px",
        "margin-bottom": "20px",
        "text-align": "center",
      },
    },
    [
      _vm.sendStatus === 1
        ? _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.$emit("save", 10)
                },
              },
            },
            [_vm._v("提交")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canOperate
        ? _c(
            "el-dropdown",
            {
              staticStyle: { "margin-left": "12px" },
              attrs: { placement: "top" },
              on: { command: _vm.handleCommand },
            },
            [
              _c("el-button", { attrs: { type: "primary", plain: "" } }, [
                _vm._v("\n      更多"),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "el-dropdown-item",
                    { attrs: { command: "revoke", icon: "el-icon-edit" } },
                    [_vm._v("撤销")]
                  ),
                  _vm._v(" "),
                  _vm.showStepBack
                    ? _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: "stepBack:" + _vm.prevStatus,
                            icon: "el-icon-back",
                          },
                        },
                        [_vm._v("退回上一级")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: {
                        command: "shipmentNote",
                        icon: "el-icon-download",
                      },
                    },
                    [_vm._v("出货单")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showRemind
        ? _c(
            "el-button",
            {
              attrs: {
                type: _vm.remindReadStatus === 1 ? "success" : "warning",
                icon: "el-icon-bell",
                loading: _vm.reminding,
                disabled: _vm.remindReadStatus != null,
              },
              on: { click: _vm.handleRemind },
            },
            [_vm._v(_vm._s(_vm.remindLabel))]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }